//Third party libraries
import { CubeIcon } from '@heroicons/react/24/outline';
//Services
import { useDashboardData } from '../../../hooks/ReactQueryHooks/useDashboardQuery';
import type { DashboardType } from '../../../types/Analytics';
//Custom components
import StatCard from '../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../UI/NumberFormatDisplay/CurrencyFormatDisplay';
//Assets and miscellaneous
import { Widget } from '../constants';
import WidgetLayout from '../WidgetLayout';

const RebuildLoansApprovedWidget = ({ dashboard }: { dashboard: DashboardType }) => {
  const fetchRebuildLoansApprovedWidgetData = useDashboardData({
    dashboard,
    widget: Widget.REBUILD_LOANS_APPROVED,
  });

  const rebuildLoansApprovedWidgetData = fetchRebuildLoansApprovedWidgetData?.data?.data?.total;

  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.REBUILD_LOANS_APPROVED} actionsBtnLocation='top-2 right-0'>
      <StatCard
        title='Rebuild Loans Approved'
        stat={rebuildLoansApprovedWidgetData ? <CurrencyFormatDisplay value={rebuildLoansApprovedWidgetData} prefix='$' /> : '$0'}
        toolTip='Total $$ of CCLF loan dollars allocated for Rebuild developers'
        icon={<CubeIcon className='w-14 sm:w-12 h-14 sm:h-12 text-secondaryColor-normal' />}
      />
    </WidgetLayout>
  );
};

export default RebuildLoansApprovedWidget;
